import React from "react";
import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { useHistory, useNavigate } from "react-router-dom";
import * as ROUTES from "../constants/Routes";
import { useTranslation } from "react-i18next";
import { ContactSupport, Instagram, LinkedIn, Policy, Twitter, Web } from "@mui/icons-material";

function Footer() {
  const { t } = useTranslation();
  const navigation = useNavigate();

  return (
    <Grid item x={12} container style={{ backgroundColor: "white", marginTop: 32, boxShadow: "rgba(100, 100, 111, 0.2) 0px 0px 16px 0px" }}>
      <Grid
        item
        xs={12}
        container
        justifyContent="flex-end"
        style={{
          borderBottom: "solid 1px rgba(0,0,0,.12)",
          padding: "36px 108px",
        }}
        alignItems="center"
      >
        <Typography
          style={{
            color: "#9aa0a6",
            font: "400 16px/26px Google Sans,Arial,sans-serif",
            marginRight: 9,
          }}
        >
          {t("contacto")}
        </Typography>

        <Tooltip title={t("privacyPolicy")} placement="top">
          <IconButton onClick={() => navigation(ROUTES.POLICY)}>
            <Policy />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
}

export default Footer;
